module.exports = __webpack_public_path__ + "6127e864b2afb5b6de63b27e0bf555bf.png";